import { Option } from '@shared/types';
import { Capitalize } from '@shared/utils';

import {
  AcademicBackground,
  AddProvidedUserInfoToCreditStudyCommand,
  ContractType,
  CreditStudyId,
  DateOfBirth,
  DeclarationIncome,
  DeclarationRent,
  EmployerName,
  EmploymentSituationName,
  HasDependents,
  IncomingSource,
  MaritalStatus,
  NumberPayRentsInAdvance,
} from '../../domain';

export class ApplicantCharacterizationFormData {
  civilStatus!: Option<MaritalStatus>;
  highestAcademicLevel!: Option<AcademicBackground>;
  employmentSituation!: Option<EmploymentSituationName>;
  incomeLevel!: number;
  rentDeclaration!: number;
  economicDependents!: number;
  businessName?: string;
  typeOfContract?: Option<ContractType>;
  incomingSource?: string;
  dateOfBirth!: Date;
  issueDate?: string;
  payRentsInAdvance!: number;
  numberPayRentsInAdvance?: number;

  static asAddProvidedUserInfoToCreditStudyCommand = (
    creditStudy: CreditStudyId,
    formData: ApplicantCharacterizationFormData
  ): AddProvidedUserInfoToCreditStudyCommand => ({
    creditStudy,
    maritalStatus: formData.civilStatus.value,
    academicBackground: formData.highestAcademicLevel.value,
    employmentSituation: formData.employmentSituation.value,
    employerName: formData.businessName ? new EmployerName(Capitalize(formData.businessName)) : undefined,
    contractType: formData.typeOfContract?.value,
    incomingSource: formData.incomingSource ? new IncomingSource(formData.incomingSource) : undefined,
    declaredIncoming: new DeclarationIncome(formData.incomeLevel),
    declaresRent: new DeclarationRent(Boolean(Number(formData.rentDeclaration))),
    hasDependents: new HasDependents(Boolean(Number(formData.economicDependents))),
    dateOfBirth: new DateOfBirth(formData.dateOfBirth.valueOf()),
    numberPayRentsInAdvance: new NumberPayRentsInAdvance(Number(formData.numberPayRentsInAdvance || 0)),
  });
}
